import { ConfigurationStatus } from "@/api/dtos";
import InstitutionContext from "@/contexts/data/InstitutionContext";
import InstitutionsContext from "@/contexts/data/InstitutionsContext";
import TrialContext from "@/contexts/data/TrialContext";
import { LinkContext } from "@/contexts/layouts/LinkContext";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Divider, Menu, MenuItem, styled } from "@mui/material";
import { FC, MouseEvent, useContext, useMemo, useState } from "react";
import { Link as RouteLink } from 'react-router-dom';

const StyledDivider = styled(Divider)(({ theme}) => ({
    margin: `0 !important`
}));

const NavigationInstitutionSelector: FC = () => {
    const { createTrialLink, createInstitutionLink, institutionLinkEnabled } = useContext(LinkContext);
    
    const { data: trial} = useContext(TrialContext);
    const { data: institution } = useContext(InstitutionContext);
    const { data: institutions } = useContext(InstitutionsContext);
    
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleMenu = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const list = useMemo(() => {
        if (!trial) {
            return undefined;
        }
        
        return institutions?.filter(x => !!x.status && x.status !== ConfigurationStatus.Disabled).map((x, i, a) => {
            return (
                [
                    <MenuItem key={x.oid} component={RouteLink} to={createInstitutionLink(trial, x)} onClick={handleClose}>{x.name}</MenuItem>,
                    i < (a.length - 1) ? <StyledDivider key={`${x.code}-divider`} /> : null
                ]
            );
        })
    }, [institutions, trial, createInstitutionLink, handleClose])

    if (!institutionLinkEnabled || !trial) {
        return null;
    }
    
    return (
        <>
            <Button
                id="btn-institutions"
                color="inherit"
                aria-label="institution selection"
                aria-controls="menu-institutions"
                aria-haspopup="true"
                sx={{mr: 2}}
                onClick={handleMenu}
                endIcon={<FontAwesomeIcon icon={faChevronDown} style={{fontSize: '1rem'}} fixedWidth />}
            >
                {
                    institution ?
                        institution.name :
                        'All Institutions'
                }
            </Button>
            <Menu
                id="menu-institutions"
                anchorEl={anchorEl}
                keepMounted
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={anchorEl?.id === 'btn-institutions'}
                onClose={handleClose}
                MenuListProps={{
                    disablePadding: true
                }}
            >
                <MenuItem component={RouteLink} to={createTrialLink(trial)} onClick={handleClose}>All Institutions</MenuItem>
                <StyledDivider />
                {list}
            </Menu>
        </>
    )
}

export default NavigationInstitutionSelector;